module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.ttf?6ee0bdf1a4b4aad88663dfb01ef6f789";